import React, { useState, useEffect } from 'react';
import {
  Platform,
  StatusBar,
  StyleSheet,
  Text,
  View,
  ImageBackground
} from "react-native";

import { COLORS, SIZES, IMAGES, FONTS } from '../constants';
import { useNavigation, useIsFocused } from '@react-navigation/native';

import { OutlineBtn } from "../components";

import AsyncStorage from '@react-native-async-storage/async-storage';

export default function HomeScreen() {

  const navigation = useNavigation();
  const isFocused = useIsFocused();

  const [disciplinesInfo, setDisciplinesInfo] = useState();

  const [isLoading, setIsLoading] = useState(true);
  const [isDisabled, setIsDisabled] = useState(true);
  const [isDisciplinesSet, setIsDisciplinesSet] = useState(false);

  const getData = async () => {
    try {

      await AsyncStorage.multiGet(['@disciplines', '@profile']).then(response => {

        setDisciplinesInfo(JSON.parse(response[0][1]));

        // if (response[0][1] !== null) {
        //   Object.keys((JSON.parse(response[0][1]))).forEach(function(key){
        //     if ( (JSON.parse(response[0][1]))[key] ) {
        //       setIsDisciplinesSet(true)
        //       setIsDisabled(prev => !prev)
        //     } else {
        //       setIsDisciplinesSet(false) 
        //       setIsDisabled(true)
        //     }
        //   })

       
        // console.log("isDisciplinesSet: ", isDisciplinesSet)

        if ( (JSON.parse(response[0][1])).d1 && (JSON.parse(response[0][1])).d2 && (JSON.parse(response[0][1])).d3 && (JSON.parse(response[0][1])).d4 && response[1][1]) {
          setIsDisabled(false);
        } 
        // else 
        // {
        //   console.log("Egzamin isDisabled ", isDisabled);
        //   console.log("Profil:", response[1][0], response[1][1]);
        //   console.log("Dyscypliny: ", response[0][0], (JSON.parse(response[0][1])));
        // }
    
      })

    } catch (e) {
      console.log("error", e)
    }
    setIsLoading(false);
  }

  useEffect(() => {
    isFocused && getData();
  }, [isFocused]);

  return (

    <ImageBackground
      source={IMAGES.bg}
      style={styles.bg}
    >
      <View style={styles.container}>
        <View style={styles.header}>
          <Text
            style={styles.titleText}
          >
            {/* Sprawdzian {"\n"} */}
            sprawności fizycznej
          </Text>
          <Text
            style={styles.subtitleText}
          >
            żołnierzy zawodowych</Text>
        </View>

        <OutlineBtn
          text="Moje dane"
          disabled={false}
          iconName="account-circle"
          iconSize={24}
          iconColor={COLORS.primary}
          onPress={() => navigation.navigate('Profile')}
        />
        <OutlineBtn
          text="Kalkulator BMI"
          disabled={false}
          iconName="accessibility-new"
          iconSize={24}
          iconColor={COLORS.primary}
          onPress={() => navigation.navigate('BMI')}
        />
        <OutlineBtn
          text="EGZAMIN"
          disabled={isDisabled}
          iconName="calculate"
          iconSize={24}
          iconColor={COLORS.primary}
          onPress={() => navigation.navigate('FinalTest')}

        />
        <OutlineBtn
          text="Autor"
          disabled={false}
          iconName="copyright"
          iconSize={24}
          iconColor={COLORS.primary}          
          onPress={() => navigation.navigate('Author')}
        />

      </View>

    </ImageBackground>
  );
}

const styles = StyleSheet.create({
  container: {
    // alignItems: 'center',
    // justifyContent: 'center',
    padding: Platform.OS === "ios" ? 40 : StatusBar.currentHeight + 10,
    flex: 1,
    padding: SIZES.padding,
    // backgroundColor: COLORS.background,
  },
  header: {
    // backgroundColor: COLORS.background,
    // justifyContent: 'flex-start',
  },
  titleText: {
    ...FONTS.title
  },
  subtitleText: {
    ...FONTS.subtitle,
    color: COLORS.secondary
  },
  bg: {
    width: "100%",
    height: "100%"
  },
});